import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KerstShowComponent } from './kerst-show/kerst-show.component';

const routes: Routes = [
  { path: '', component: KerstShowComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
